import styles from './SearchInput.module.css';

export const SearchInput = ({
  placeholder = 'Поиск...',
  value,
  onChange,
  onFocus,
  onBlur,
  loading = false,
  suggestions = [],
  showEmpty = false,
  emptyMessage = 'Ничего не найдено',
  onSelectSuggestion,
  active = true,
}) => {
  const shouldShowDropdown = active && (loading || suggestions.length > 0 || showEmpty);

  return (
    <div className={styles.searchContainer}>
      <svg
        className={styles.searchIcon}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <circle
          cx="9"
          cy="9"
          r="7"
          stroke="#9CA3AF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 14L17 17"
          stroke="#9CA3AF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <input
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {shouldShowDropdown ? (
        <div className={styles.dropdown}>
          {loading ? <div className={styles.dropdownItem}>Ищем...</div> : null}
          {!loading && showEmpty ? (
            <div className={`${styles.dropdownItem} ${styles.dropdownEmpty}`}>{emptyMessage}</div>
          ) : null}
          {!loading && suggestions.map((item) => (
            <button
              key={item.key}
              type="button"
              className={styles.dropdownItem}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onSelectSuggestion?.(item)}
            >
              <span className={styles.dropdownTitle}>{item.title}</span>
              <span className={styles.dropdownMeta}>{item.meta}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};
